import { connect } from 'react-redux';
import { selectProduct } from 'Favourites/store/reducers/data/products';

const mapStateToProps = (state, ownProps) => {
    const productId = ownProps.productId;
    const product = selectProduct(state, productId);
    const parts = product.childProducts;
    const showChildren = product.showChildren || false;

    return { productId, parts, showChildren };
};

export default connect(mapStateToProps);
